import React from "react";
import ProductGrid from "./components/ProductGrid";

function Bundles() {
  return <ProductGrid params={{ category: "bundle" }} />;
}

export default Bundles;
